import type {ReactNode} from 'react';

export type IconName =
  | 'home'
  | 'sparkles'
  | 'globe'
  | 'box'
  | 'palette'
  | 'eye'
  | 'rocket'
  | 'settings'
  | 'chevronDown'
  | 'chevronRight'
  | 'arrowUpRight'
  | 'plus'
  | 'search'
  | 'more'
  | 'check'
  | 'clock'
  | 'image'
  | 'layers'
  | 'external'
  | 'mobile'
  | 'monitor'
  | 'arrowLeft'
  | 'refresh'
  | 'sliders'
  | 'wand'
  | 'shield'
  | 'dots';

const paths: Record<IconName, ReactNode> = {
  home: <><path d="m3 10 9-7 9 7v10a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1Z"/><path d="M8 21h8"/></>,
  sparkles: <><path d="m12 3-1.2 3.7a2 2 0 0 1-1.3 1.3L5.8 9.2l3.7 1.2a2 2 0 0 1 1.3 1.3L12 15.4l1.2-3.7a2 2 0 0 1 1.3-1.3l3.7-1.2-3.7-1.2a2 2 0 0 1-1.3-1.3Z"/><path d="m19 14-.6 1.8a1 1 0 0 1-.6.6L16 17l1.8.6a1 1 0 0 1 .6.6L19 20l.6-1.8a1 1 0 0 1 .6-.6L22 17l-1.8-.6a1 1 0 0 1-.6-.6Z"/><path d="m5 3-.5 1.5a1 1 0 0 1-.7.7L2.3 5.7l1.5.5a1 1 0 0 1 .7.7L5 8.4l.5-1.5a1 1 0 0 1 .7-.7l1.5-.5-1.5-.5a1 1 0 0 1-.7-.7Z"/></>,
  globe: <><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/></>,
  box: <><path d="m3.5 7.5 8.5-4 8.5 4v9l-8.5 4-8.5-4Z"/><path d="m3.5 7.5 8.5 4 8.5-4M12 11.5v9"/></>,
  palette: <><path d="M12 3a9 9 0 0 0 0 18h1.1a1.9 1.9 0 0 0 1.1-3.4 1.9 1.9 0 0 1 1.1-3.4H17A4 4 0 0 0 21 10C20 6 16.5 3 12 3Z"/><circle cx="7.5" cy="10" r=".8" fill="currentColor" stroke="none"/><circle cx="10" cy="7" r=".8" fill="currentColor" stroke="none"/><circle cx="14" cy="7" r=".8" fill="currentColor" stroke="none"/></>,
  eye: <><path d="M2.5 12s3.3-5 9.5-5 9.5 5 9.5 5-3.3 5-9.5 5-9.5-5-9.5-5Z"/><circle cx="12" cy="12" r="2.2"/></>,
  rocket: <><path d="M14.6 4.1c2.4-1.9 5-2.1 5.3-2.1 0 .3-.2 2.9-2.1 5.3l-4.4 4.4-3.2-3.2Z"/><path d="m10.2 8.5-3.5.8-2.4 2.4 4.1.6M13.4 11.7l-.8 3.5-2.4 2.4-.6-4.1"/><path d="m8.8 15.2-2 2.8-3 1 .9-3 2.8-2"/><circle cx="16.6" cy="6.4" r="1.1"/></>,
  settings: <><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1-1.8 1.8-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.5v.2h-2.5v-.2a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.9.3l-.1.1-1.8-1.8.1-.1A1.7 1.7 0 0 0 8.1 15a1.7 1.7 0 0 0-1.5-1H6.4v-2.5h.2a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.9l-.1-.1 1.8-1.8.1.1a1.7 1.7 0 0 0 1.9.3 1.7 1.7 0 0 0 1-1.5v-.2H15v.2a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.9-.3l.1-.1 1.8 1.8-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.5 1h.2V14h-.2a1.7 1.7 0 0 0-1.5 1Z"/></>,
  chevronDown: <path d="m6 9 6 6 6-6"/>,
  chevronRight: <path d="m9 18 6-6-6-6"/>,
  arrowUpRight: <><path d="M7 17 17 7M8 7h9v9"/></>,
  plus: <><path d="M12 5v14M5 12h14"/></>,
  search: <><circle cx="10.8" cy="10.8" r="6.8"/><path d="m16 16 5 5"/></>,
  more: <><circle cx="5" cy="12" r="1" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1" fill="currentColor" stroke="none"/><circle cx="19" cy="12" r="1" fill="currentColor" stroke="none"/></>,
  check: <path d="m5 12 4 4L19 6"/>,
  clock: <><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></>,
  image: <><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8.5" cy="9" r="1.5"/><path d="m4 17 4.5-4.5 3.5 3 2.5-2.5L20 18"/></>,
  layers: <><path d="m12 3 9 5-9 5-9-5 9-5Z"/><path d="m3 12 9 5 9-5M3 16l9 5 9-5"/></>,
  external: <><path d="M14 4h6v6M20 4l-9 9"/><path d="M18 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5"/></>,
  mobile: <><rect x="7" y="2.5" width="10" height="19" rx="2"/><path d="M10 5h4M11 18.5h2"/></>,
  monitor: <><rect x="3" y="4" width="18" height="13" rx="2"/><path d="M8 21h8M12 17v4"/></>,
  arrowLeft: <><path d="M19 12H5M12 19l-7-7 7-7"/></>,
  refresh: <><path d="M20 11a8 8 0 0 0-14.9-3M4 5v4h4M4 13a8 8 0 0 0 14.9 3M20 19v-4h-4"/></>,
  sliders: <><path d="M4 6h16M4 12h16M4 18h16"/><circle cx="8" cy="6" r="2" fill="var(--surface, #fff)"/><circle cx="16" cy="12" r="2" fill="var(--surface, #fff)"/><circle cx="10" cy="18" r="2" fill="var(--surface, #fff)"/></>,
  wand: <><path d="m15 4 5 5M5 19 18 6M4 5l1 2 2 1-2 1-1 2-1-2-2-1 2-1Z"/><path d="m18 15 .7 1.5L20 17l-1.3.5L18 19l-.7-1.5L16 17l1.3-.5Z"/></>,
  shield: <><path d="M12 3 20 6v5c0 5-3.4 8.3-8 10-4.6-1.7-8-5-8-10V6Z"/><path d="m8 12 2.5 2.5L16 9"/></>,
  dots: <><circle cx="12" cy="5" r="1" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1" fill="currentColor" stroke="none"/><circle cx="12" cy="19" r="1" fill="currentColor" stroke="none"/></>,
};

export default function Icon({name, size = 18, strokeWidth = 1.8}: {name: IconName; size?: number; strokeWidth?: number}) {
  return (
    <svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      {paths[name]}
    </svg>
  );
}
